import { useState } from "react";

const useAesGcmEncrypt = () => {
  const [encryptedData, setEncryptedData] = useState(null);

  // Helper function to convert ArrayBuffer to base64
  const arrayBufferToBase64 = (buffer) => btoa(String.fromCharCode(...new Uint8Array(buffer)));

  // Encrypt function
  const encrypt = async (text) => {
    try {
      const iv = window.crypto.getRandomValues(new Uint8Array(12)); // 12 bytes for AES-GCM IV
      const enc = new TextEncoder();

      // Generate a random AES key for each encryption
      const key = await window.crypto.subtle.generateKey(
        { name: "AES-GCM", length: 256 },
        true,
        ["encrypt", "decrypt"]
      );

      const exportedKey = await window.crypto.subtle.exportKey("raw", key);
      const keyBase64 = arrayBufferToBase64(exportedKey);

      // Encrypt the text
      const encrypted = await window.crypto.subtle.encrypt(
        { name: "AES-GCM", iv },
        key,
        enc.encode(text)
      );

      const encryptedBase64 = arrayBufferToBase64(encrypted);
      const ivBase64 = arrayBufferToBase64(iv);

      setEncryptedData({ encryptedBase64, ivBase64, keyBase64 });
      
      return { encryptedBase64, ivBase64, keyBase64 }; // return encrypted data, IV, and key
    } catch (error) {
      console.error("Encryption error:", error);
      throw error;
    }
  };

  return { encrypt, encryptedData };
};

export default useAesGcmEncrypt;
